import { FunctionComponent } from 'react';
import styles from './PetTypeTag.module.scss';
import clsx from 'clsx';
import { PetType, PetTypeIds } from '@spike/model';

interface PetTypeTagProps {
    petType: PetType;
    className?: string;
}

export const PetTypeTag: FunctionComponent<PetTypeTagProps> = props => {
    return (
        <div
            className={clsx(
                styles.container,
                {
                    [styles.dog]: props.petType.id === PetTypeIds.DOGS,
                    [styles.cat]: props.petType.id === PetTypeIds.CATS,
                    [styles.exotic]: props.petType.id === PetTypeIds.EXOTICS
                },
                props.className
            )}
        >
            <span className={styles.text}>{props.petType.plural}</span>
        </div>
    );
};

export default PetTypeTag;
